import { combineReducers } from "redux";
import tableReducer from "./tableReducer";
import viewerReducer from "./viewerReducer";
import userReducer from "./userReducer";
import conditionReducer from "./conditionReducer";
import colorSidebarReducer from "./colorSidebarReducer";
import tabsSettingsReducer from "./tabsSettingsReducer";
import translationsReducer from "./translationsReducer";
import { MERGE_SYNCED_STATE } from "utils/crossTabSync";

const appReducer = combineReducers({
  viewer: viewerReducer,
  table: tableReducer,
  tabsSettings: tabsSettingsReducer,
  user: userReducer,
  condition: conditionReducer,
  colorSidebar: colorSidebarReducer,
  translations: translationsReducer,
});

export default function rootReducer(state, action) {
  if (action?.type === MERGE_SYNCED_STATE) {
    const inc = action.payload || {};
  
    const localSelectedRows = state.table?.currentTableState?.selectedRows || [];
    const localTabs = state.table?.tabs || [];
    const localTabsWithSelection = localTabs.map(tab => ({
      selectedRows: tab.selectedRows || [],
      selectedItems: tab.selectedItems || [],
    }));
  
    let nextState = {
      ...state,
      ...(inc.table ? { 
        table: { 
          ...state.table, 
          ...inc.table,
          currentTableState: {
            ...inc.table?.currentTableState,
            selectedRows: localSelectedRows, // Keep local selection
          },
          tabs: inc.table?.tabs ? inc.table.tabs.map((remoteTab) => {
            const localTab = localTabs.find(t => t.id === remoteTab.id && t.modelId === remoteTab.modelId);
            return {
              ...remoteTab,
              selectedRows: localTab?.selectedRows || [],
              selectedItems: localTab?.selectedItems || [],
            };
          }) : state.table.tabs,
        } 
      } : {}),
      ...(inc.tabsSettings ? { tabsSettings: { ...state.tabsSettings, ...inc.tabsSettings } } : {}),
      ...(inc.translations ? { translations: { ...state.translations, ...inc.translations } } : {}),
      ...(inc.colorSidebar ? { colorSidebar: { ...state.colorSidebar, ...inc.colorSidebar } } : {}),
      ...(inc.condition ? { condition: { ...state.condition, ...inc.condition } } : {}),
      ...(inc.viewer ? { viewer: { ...state.viewer, ...inc.viewer } } : {}),
    };
  
    if (inc.viewer?.templateSettings) {
      nextState = {
        ...nextState,
        viewer: {
          ...nextState.viewer,
          templateSettings: {
            ...state.viewer?.templateSettings,
            ...inc.viewer.templateSettings,
          },
        },
      };
    }
  
    return nextState;
  }
  return appReducer(state, action);
}